//@ts-nocheck
import { Box, BoxProps, ColorOptions, Image, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'

interface SectionListProps {
  data: any
  breakpoint?: any
  index?: any
  navigation?: any
}

const SectionList: FC<SectionListProps> = ({ data, navigation }: SectionListProps) => {
  const viewPortWidth = useWindowDimensions()
  const respPadding = usePadding()

  const themedStyle = styles(viewPortWidth, respPadding)

  return (
    <Box {...themedStyle.container}>
      {data.map((item: any, index: any) => {
        return <SectionItem data={item} breakpoint={viewPortWidth} index={index} navigation={navigation} />
      })}
    </Box>
  )
}

const SectionItem: FC<SectionListProps> = ({ data, breakpoint, index, navigation }: SectionListProps) => {
  const { headerSize, subHeaderSize, textSize, headerLineHeight, subHeaderLineHeight, fontSizeSmall } = useFontSize()
  const respPadding = usePadding()
  const themedStyle = styles(breakpoint, respPadding)
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)

  const lineHeight = textSize * 1.5

  const handleNav = () => {
    navigation.navigate(data?.uri)
  }
  const isLeft = index % 2 === 0
  return (
    <Box {...themedStyle.listContainer} flexDirection={isLeft ? 'row' : 'row-reverse'}>
      <Box
        onPress={handleNav}
        width={isMobile ? '100%' : '46%'}
        minWidth={isMobile || isTab ? 250 : 280}
        minHeight={isMobile || isTab ? 250 : 280}
        underlayColor={'TRANSPARENT'}
        ml={isMobile ? 0 : isLeft ? '-0.35%' : 0}
        mr={isMobile ? 0 : isLeft ? 0 : -40}
        alignSelf="flex-start"
        alignItems={isMobile ? 'center' : isTab ? 'flex-start' : isLeft ? 'flex-start' : 'flex-end'}>
        <Image
          resizeMode="contain"
          source={data.image}
          height={isMobile ? '100%' : isTab ? 320 : 560}
          width={isMobile ? '100%' : isTab ? 290 : '100%'}
        />
      </Box>
      <Box width={isMobile ? '100%' : '47%'} minWidth={280} alignSelf="center" mt={isMobile ? 38 : 0}>
        <Text fontSize={headerSize} lineHeight={headerLineHeight} fontFamily="jiotype-black">
          {data.header}
        </Text>
        <Spacer size={14} />
        <Box
          borderWidth="BIG"
          width="10%"
          minWidth={56}
          height={4}
          backgroundColor={'BLUE_SHADE_PRIMARY'}
          borderRadius="8"
        />
        <Spacer size={isMobile ? 32 : isTab ? 24 : 42} />
        <Text fontSize={subHeaderSize} lineHeight={subHeaderLineHeight} fontFamily="jiotype-bold">
          {data.subheader}
        </Text>
        <Spacer size={isMobile || isTab ? 16 : 'BIG'} direction="vertical" />
        <Text fontSize={textSize} color="BRAND_COLOR_GRAY_1" lineHeight={lineHeight + 2} fontFamily="jiotype-medium">
          {data?.text}
        </Text>
        <Spacer size={isMobile ? 40 : isTab ? 30 : 45} />
        <Box
          direction={isMobile || isTab ? 'column' : 'row'}
          flexWrap={'wrap'}
          justifyContent="space-between"
          height={isMobile ? 229 : undefined}>
          <Box flex={isTab ? undefined : 0.46}>
            <Box h={32} w={128} borderRadius={16} bg={'#24397A' as ColorOptions} justify={'center'} align={'center'}>
              <Text
                title={'ADVANTAGE'}
                color={'WHITE'}
                fontSize={fontSizeSmall}
                letterSpacing={1.4}
                fontFamily={'jiotype-bold'}
              />
            </Box>
            <Spacer direction={'vertical'} size={isMobile ? 24 : 20} />
            <Box width="100%">
              <Text fontSize={textSize} color="BRAND_COLOR_GRAY_1" lineHeight={lineHeight} fontFamily="jiotype-medium">
                {data?.advantage}
              </Text>
            </Box>
          </Box>
          <Spacer size={isMobile ? 40 : isTab ? 30 : 0} />
          <Box flex={isTab ? undefined : 0.47}>
            <Box h={32} w={128} borderRadius={16} bg={'#24397A' as ColorOptions} justify={'center'} align={'center'}>
              <Text
                title={'IDEAL FOR'}
                color={'WHITE'}
                fontSize={fontSizeSmall}
                letterSpacing={1.4}
                fontFamily={'jiotype-bold'}
              />
            </Box>
            <Spacer direction={'vertical'} size={isMobile ? 24 : 20} />
            <Box width="100%">
              <Text fontSize={textSize} color="BRAND_COLOR_GRAY_1" lineHeight={lineHeight} fontFamily="jiotype-medium">
                {data?.idealFor}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const styles = (viewPortWidth: number, responsivePadding: number) => {
  const isTab = isTabletWidth(viewPortWidth)
  const isMob = isMobileWidth(viewPortWidth)
  return {
    container: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingHorizontal: responsivePadding,
      bg: 'WHITE',
      mt: isMob ? 180 : 0,
    } as BoxProps,
    listContainer: {
      minHeight: isTab ? '30vh' : '70vh',
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      paddingVertical: isMob ? 0 : isTab ? 40 : 32,
      marginTop: isMob ? 0 : 60,
      marginBottom: isMob ? 160 : isTab ? 10 : 60,
    } as BoxProps,
  }
}

export default SectionList
